var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-input-wrapper"},[_c('input',{ref:"uploadEml",staticClass:"upload-eml-input",attrs:{"type":"file","accept":".eml"},on:{"change":_vm.handleFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }